/**
 * Uygulama yapılandırma dosyası
 */

// api urlleri
export const API_URL = process.env.REACT_APP_API_URL;

// api url değişme fonk
export const setApiUrl = (newUrl) => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('api_url', newUrl);
    }
};

// güncel api alma fonk
export const getApiUrl = () => {
    if (typeof window !== 'undefined') {
        const savedUrl = localStorage.getItem('api_url');
        return savedUrl || API_URL;
    }
    return API_URL;
};

// api url'i localStorage'dan silme fonk
export const clearApiUrl = () => {
    if (typeof window !== 'undefined') {
        localStorage.removeItem('api_url');
    }
}; 